"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("../index.scss");
const ProfileAccountInfoSection_1 = require("@Components/ProfileAccountInfoSection");
const GetVerifiedPopup_1 = __importDefault(require("@Components/Popups/GetVerifiedPopup"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const user_statuses_1 = require("@Const/user-statuses");
const contexts_1 = require("@App/contexts");
const userinfo_to_zod_mapper_1 = require("@App/helpers/userinfo-to-zod-mapper");
const user_info_schema_1 = require("@Entities/schemas/user/user-info-schema");
const UserInfoSection_1 = __importDefault(require("@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserView/UserInfoSection"));
const AddressSection_1 = __importDefault(require("@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserView/AddressSection"));
const TopSection_1 = __importDefault(require("@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserView/TopSection"));
const ContactInfoSection_1 = __importDefault(require("@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserView/ContactInfoSection"));
const error_messages_1 = require("@Const/error-messages");
const ProfileSceneUserView = (props) => {
    const { setEditable } = props;
    const { preloaderStore, popupStore, userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const userInfo = userStore.userInfo;
    const isInternal = Boolean(userInfo.isInternalUser);
    const phoneNumberTitle = userStore.phoneNumberDisplay;
    const countryTitle = userStore.countryTitle;
    const [getVerifiedPopupIsOpen, setGetVerifiedPopupIsOpen] = (0, react_1.useState)(false);
    const [isVerifyingKyc, setIsVerifyingKyc] = (0, react_1.useState)(false);
    const setIsVerifying = (isVerifying) => {
        setIsVerifyingKyc(isVerifying);
        preloaderStore.openTransparentPreloader(isVerifying);
    };
    const getVerified = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!profileReadyForKyc()) {
            setGetVerifiedPopupIsOpen(true);
        }
        else {
            setIsVerifying(true);
            userStore
                .attemptKycForCurrentUser()
                .then(() => popupStore.setAlertData('Congratulations, your account has been submitted for verification!', false))
                .catch(() => popupStore.setAlertData(error_messages_1.FAILED_VERIFICATION_MESSAGE, true))
                .finally(() => setIsVerifying(false));
        }
    });
    const profileReadyForKyc = () => {
        if (!userInfo || userInfo.verificationStatus === user_statuses_1.USER_VERIFICATION_STATUSES.REJECTED) {
            return false;
        }
        const zodMappedData = (0, userinfo_to_zod_mapper_1.userinfoToZodMapper)(userInfo);
        return user_info_schema_1.userInfoSchema.safeParse(zodMappedData).success;
    };
    return (react_1.default.createElement("div", { className: 'profile-scene-user-tab' },
        react_1.default.createElement(TopSection_1.default, { userInfo: userInfo, isInternal: isInternal, onClick: () => setEditable(true) }),
        react_1.default.createElement(ProfileAccountInfoSection_1.ProfileAccountInfoSection, { isRunningKyc: isVerifyingKyc, userInfo: userInfo, getVerified: getVerified }),
        react_1.default.createElement(UserInfoSection_1.default, { userInfo: userInfo }),
        react_1.default.createElement(AddressSection_1.default, { userInfo: userInfo, countryTitle: countryTitle }),
        react_1.default.createElement(ContactInfoSection_1.default, { userInfo: userInfo, phoneNumberTitle: phoneNumberTitle }),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: getVerifiedPopupIsOpen },
            react_1.default.createElement(GetVerifiedPopup_1.default, { status: userInfo.verificationStatus, onCloseConfirmPopup: () => setGetVerifiedPopupIsOpen(false), clickEditProfile: () => setEditable(true) }))));
};
exports.default = ProfileSceneUserView;
